import { createSlice } from '@reduxjs/toolkit'
import { fetchReportHistory } from './report-manager-thunks'
import { ReservationNoteCategory } from '@/models/reservation/reservation-note'
import * as ReportModel from '@/models/report'

type StateType = {
  isFetching: boolean
  exportHistories: ReportModel.ExportHistory[]
  hasExportInProgress: boolean
}

export type ReportFormType = {
  type: ReportModel.ReportTypes
  format: 'csv' | 'pdf'
  date: string
  month: string
  period: {
    startDate: string
    endDate: string
  }
  isIncludeTax: '1' | '0'
  subjectCodes: string[]
  noteCategory: ReservationNoteCategory
}

export const reportManagerSlice = createSlice({
  name: 'reportManager',
  initialState: {
    isFetching: false,
    exportHistories: [],
    hasExportInProgress: false,
  } as StateType,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchReportHistory.fulfilled, (state, action) => {
      state.exportHistories = action.payload
      state.hasExportInProgress = state.exportHistories.some(h => h.status === ReportModel.ExportStatus.inProcess)
      state.isFetching = false
    })
    builder.addCase(fetchReportHistory.pending, state => {
      state.isFetching = true
    })
    builder.addCase(fetchReportHistory.rejected, (state, action) => {
      // condition によるキャンセル時（dispatchConditionRejection: true）の rejected では isFetching を変更しない
      if (action.meta?.condition) return
      state.isFetching = false
    })
  },
})

export const reportManagerReducer = reportManagerSlice.reducer
